import React, { useState, useEffect, useRef } from "react";
import Form from "react-validation/build/form";
import CheckButton from "react-validation/build/button";
import { useForm } from "react-hook-form";
import { toast, ToastContainer } from "react-toastify";
import CSVFileValidator from "csv-file-validator";

import { API } from "../backend";
import authHeader from "../services/auth-header";
import { getTrans as t } from "../Localization/translations";
import EditCompanyService from "../services/company/editCompanyService";


function Import() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [successful, setSuccessful] = useState(false);
  const [message, setMessage] = useState(null);
  const [apiResponse, setApiResponse] = useState(null);
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const form = useRef();
  const checkBtn = useRef();
  const [select, setSelect] = useState("");

  const [parsedData, setParsedData] = useState([]);
  const [csvData, setCsvData] = useState([]);
  const [tableRows, setTableRows] = useState([]);

  const [values, setValues] = useState([]);

  const [party, setParty] = useState(false);
  const [partyaddress, setPartyaddress] = useState(false);
  const [partycontact, setPartyContact] = useState(false);
  const [conracts, setContract] = useState(false);
  const [contractpayment, setContractPayment] = useState(false);
  const [contractasset, setContractAsset] = useState(false);
  const [invoice, setInvoice] = useState(false);
  const [receipt, setReceipt] = useState(false);
  const [taxRate, setTaxRate] = useState(false);
  const [inventory, setInventory] = useState(false);
  const [achAccounts, setAchAccounts] = useState(false);
  const [additionalparties, setAdditionalParties] = useState(false);


  const [country_name, setCountry] = useState([]);
  const [state_name, setState] = useState([]);
  const [country, setCountryid] = useState("");
  const [state, setStateid] = useState("");
  const [ErrorsBotton, setErrorsBotton] = useState(false)

  const [isLoading2, setIsLoading2] = useState(false);
  const [inputvalue, setValue] = useState("");
  const [currentPage2, setCurrentPage2] = useState(1);
  const [options2, setOptions2] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [TaxCoutry, setTaxCoutry] = useState([])
  const [TaxCoutryId, setTaxCoutryID] = useState("")
  const [TaxState, setTaxState] = useState([])

  useEffect(() => {
    const getcountry = async () => {
      const res = await fetch(API + "helper/ajax/load-countries/");
      const getcon = await res.json();
      setCountry(await getcon);
      const data = getcon.filter((val) => val.id === 231)
      setTaxCoutry(data)
    };
    getcountry();
  }, []);

  const handlecountry = (event) => {
    const getcoutryid = event.target.value;
    setCountryid(getcoutryid);
  };

  const handlecountryTax = (event) => {
    const getcoutryid = event.target.value;
    setTaxCoutryID(getcoutryid)
  };

  const handlestate = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };
  const handlestateTax = (event) => {
    const getstateid = event.target.value;
    setStateid(getstateid);
  };

  useEffect(() => {
    // if (TaxCoutryId !== "") {
    const getstate = async () => {
      const resst = await fetch(
        API + "helper/ajax/load-states/" + 231 + "/"
      );
      const getst = await resst.json();
      setTaxState(await getst);
    };
    getstate();
    // }
  }, [TaxCoutryId]);

  useEffect(() => {
    if (country !== "") {
      const getstate = async () => {
        const resst = await fetch(
          API + "helper/ajax/load-states/" + country + "/"
        );
        const getst = await resst.json();
        setState(await getst);
      };
      getstate();
    }
  }, [country]);

  const downloadErrors = () => {
    if (apiResponse && apiResponse.errors) {
      const errorText = apiResponse.errors
        .map((error, index) => error.row_index)
      const errorTexts = apiResponse.errors
        .map((error, index) => `${error.error}`)
        .join("\n");
      let errorArray = errorTexts.split('\n');
      const filteredErrorIndices = values.filter((_, i) => errorText.includes(i + 1));
      if (!tableRows[0].includes('Error')) {
        tableRows[0].push('Error');
      }
      for (let i = 0; i < filteredErrorIndices.length; i++) {
        let trimmedArray2Element = filteredErrorIndices[i].replace(/\r/g, '');
        filteredErrorIndices[i] = trimmedArray2Element + ',' + errorArray[i] + '\r';
      }

      const csvRows = [tableRows, ...filteredErrorIndices];
      const csvContent = `${csvRows.map(row => Array.isArray(row) ? row.join(',') : row).join('\n')}`;

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      const csvUrl = URL.createObjectURL(blob);
      const csvLink = document.createElement("a");
      csvLink.href = csvUrl;
      csvLink.setAttribute("download", `${select[0].toUpperCase() + select.slice(1) + "Import_errors"}.csv`);
      document.body.appendChild(csvLink);
      csvLink.click();
      document.body.removeChild(csvLink);

    }
    else if (ErrorsBotton) {
      const groupedArray = [];
      csvData.forEach(obj => {
        const rowIndex = groupedArray.findIndex(group => group.some(item => item.rowIndex === obj.rowIndex));
        if (rowIndex !== -1) {
          groupedArray[rowIndex].push(obj);
        } else {
          groupedArray.push([obj]);
        }
      });
      const mergedArray = groupedArray.map((group) => {
        const mergedMessages = group.reduce((acc, obj) => {
          if (acc[obj.rowIndex]) {
            acc[obj.rowIndex] += ` and ${obj.message.props.children}`;
          } else {
            acc[obj.rowIndex] = obj.message.props.children;
          }
          return acc;
        }, {});

        return Object.entries(mergedMessages).map(([rowIndex, message]) => ({
          rowIndex: parseInt(rowIndex),
          message
        }));
      });
      const finalArray = mergedArray.flat()
      const errorText = finalArray.map((error, index) => error.rowIndex - 1)
      const maxIndex = Math.max(...errorText);

      const errorTexts = finalArray.map((error, index) => `${error.message}`).join("\n");

      let valArray = errorTexts.split('\n');
      let errorArray = Array.from({ length: maxIndex }, (_, index) => (errorText.includes(index + 1) ? valArray[errorText.indexOf(index + 1)] : ""));

      const filteredErrorIndices = values;

      if (!tableRows[0].includes('Error')) {
        tableRows[0].push('Error');
      }

      for (let i = 0; i < filteredErrorIndices.length; i++) {
        let trimmedArray2Element = filteredErrorIndices[i].replace(/\r/g, '');
        filteredErrorIndices[i] = trimmedArray2Element + ',' + errorArray[i] + '\r';
      }

      const csvRows = [tableRows, ...filteredErrorIndices];
      const csvContent = `${csvRows.map(row => Array.isArray(row) ? row.join(',') : row).join('\n')}`;

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      const csvUrl = URL.createObjectURL(blob);
      const csvLink = document.createElement("a");
      csvLink.href = csvUrl;
      csvLink.setAttribute("download", `${select[0].toUpperCase() + select.slice(1) + "Import_errors"}.csv`);
      document.body.appendChild(csvLink);
      csvLink.click();
      document.body.removeChild(csvLink);


    } else {
      setErrorsBotton(false)
    }
  };

  useEffect(() => {
    select === "party" ? setParty(true) : setParty(false);
    select === "partyaddress" ? setPartyaddress(true) : setPartyaddress(false);
    select === "partycontact" ? setPartyContact(true) : setPartyContact(false);
    select === "contract" ? setContract(true) : setContract(false);
    select === "contractpayment"
      ? setContractPayment(true)
      : setContractPayment(false);
    select === "contractassets"
      ? setContractAsset(true)
      : setContractAsset(false);
    select === "invoice" ? setInvoice(true) : setInvoice(false);
    select === "receipt" ? setReceipt(true) : setReceipt(false);
    select === "taxrate" ? setTaxRate(true) : setTaxRate(false);
    select === "inventory" ? setInventory(true) : setInventory(false);
    select === "achAccounts" ? setAchAccounts(true) : setAchAccounts(false);
    select === "additionalparties" ? setAdditionalParties(true) : setAdditionalParties(false);

  }, [select]);

  // const isValidYN = function (value) {
  //   return ['Y', 'N'].includes(value);
  // };

  // const isValidBoolean = function (value) {
  //   return ['true', 'false', 'Y', 'N', '1', '0'].includes(value.toLowerCase());
  // };

  const requiredError = (headerName, rowNumber, columnNumber) => {
   
    return (
      <div>
        {`${headerName} is required in the ${rowNumber - 1} row / ${columnNumber} column`}
      </div>
    )
  };


  const isEmailValid = function (email) {
    const reqExp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
    return reqExp.test(email);
  };

  const CSVConfig = {
    headers: [
      {
        name: "Party Reference",
        inputName: "Party Reference",
        required: true,
        requiredError,
      },
      {
        name: "Prefix",
        inputName: "Prefix",
        required: false,
      },
      {
        name: "First Name",
        inputName: "First Name",
        required: true,
        requiredError,
      },
      {
        name: "Middle Name",
        inputName: "Middle Name",
        required: false,
      },
      {
        name: "Last Name",
        inputName: "Last Name",
        required: true,
        requiredError,
      },
      {
        name: "Phone No",
        inputName: "Phone No",
        required: false,
        // requiredError,
      },
      {
        name: "Mobile No",
        inputName: "Mobile No",
        required: true,
        requiredError,
      },
      {
        name: "Email Address",
        inputName: "Email Address",
        required: true,
        isEmailValid,
      },
    ],
  };


  const CSVAdditionalParties = {
    headers: [
      {
        name: "Contract Number",
        inputName: "Contract Number",
        required: false,
      },
      {
        name: "Party Reference",
        inputName: "Party Reference",
        required: false,
        // requiredError,
      },
      {
        name: "Role",
        inputName: "Role",
        required: false,
        // requiredError,
      },
    ]
  }

  const CSVConfigcontractpayment = {
    headers: [
      {
        name: "Contract Number",
        inputName: "Contract Number",
        required: true,
        requiredError,
      },
      {
        name: "No of Payments",
        inputName: "No of Payments",
        required: true,
        requiredError,
      },
      {
        name: "Payment Amount",
        inputName: "Payment Amount",
        required: true,
        requiredError,
      },
      {
        name: "Payment Type",
        inputName: "Payment Type",
        required: true,
        requiredError,
      },
      {
        name: "Start Date",
        inputName: "Start Date",
        required: true,
        requiredError,
      },
      {
        name: "End Date",
        inputName: "End Date",
        required: true,
        requiredError,
      },
    ],
  };

  const CSVConfigparty = {
    headers: [
      {
        name: "Party Name",
        inputName: "Party Name",
        required: true,
        requiredError,
      },
      {
        name: "Party Type",
        inputName: "Party Type",
        required: true,
        requiredError,
      },
      {
        name: "Entity Type",
        inputName: "Entity Type",
        required: true,
        requiredError,
      },
      // {
      //   name: "Party Reference",
      //   inputName: "Party Reference",
      //   required: false,
      // },
      {
        name: "Tax Number",
        inputName: "Tax Number",
        required: false,
      },
      {
        name: "Establishment Date",
        inputName: "Establishment Date",
        required: false,
      },
      {
        name: "Sales Tax Code",
        inputName: "Sales Tax Code",
        required: false,
      },
      {
        name: "Website",
        inputName: "Website",
        required: false,
      },
      {
        name: "Prefix",
        inputName: "Prefix",
        required: false,
      },
      {
        name: "First Name",
        inputName: "First Name",
        required: false,
      },
      {
        name: "Middle Name",
        inputName: "Middle Name",
        required: false,
      },
      {
        name: "Last Name",
        inputName: "Last Name",
        required: false,
      },
      {
        name: "SSN / TIN Number",
        inputName: "SSN / TIN Number",
        required: false,
      },
      {
        name: "Id Number",
        inputName: "Id Number",
        required: false,
      },
      {
        name: "Id Issue State",
        inputName: "Id Issue State",
        required: false,
      },
      {
        name: "Date of Birth",
        inputName: "Date of Birth",
        required: false,
      },
      {
      name: "Doing Business As",
      inputName: "Doing Business As",
      required: false,
    },
      {
      name: "Business Type",
      inputName: "Business Type",
      required: false,
    },
    {
      name: "Federal ID",
      inputName: "Federal ID",
      required: false,
    },
    {
      name: "SIC",
      inputName: "SIC",
      required: false,
    },
    {
      name: "NAICS",
      inputName: "NAICS",
      required: false,
    },
    {
      name: "Risk Rating",
      inputName: "Risk Rating",
      required: false,
    },
    {
      name: "Credit Score",
      inputName: "Credit Score",
      required: false,
    },
    ],
  };

  const CSVConfigcontract = {
    headers: [
      // {
      //   name: "Contract Number",
      //   inputName: "Contract Number",
      //   required: false,
      // },
      {
        name: "Contract Type",
        inputName: "Contract Type",
        required: true,
        requiredError,
      },
      {
        name: "Customer(Party Reference)",
        inputName: "Customer(Party Reference)",
        required: true,
        requiredError,
      },
      {
        name: "Bill to Address(Address Reference)",
        inputName: "Bill to Address(Address Reference)",
        required: true,
        requiredError,
      },
      {
        name: "IRR/Interest p.a. (%)",
        inputName: "IRR/Interest p.a. (%)",
        required: false,
      },
      {
        name: "Term",
        inputName: "Term",
        required: true,
        requiredError,
      },
      {
        name: "Start Date",
        inputName: "Start Date",
        required: true,
        requiredError,
      },
      // {
      //   name: "End Date",
      //   inputName: "End Date",
      //   required: true,
      //   requiredError,
      // },
      // {
      //   name: "Payment Start Date",
      //   inputName: "Payment Start Date",
      //   required: false,
      // },
      {
        name: "Payment Rule",
        inputName: "Payment Rule",
        required: true,
        requiredError,
      },
      {
        name: "Payment Frequency",
        inputName: "Payment Frequency",
        required: true,
        requiredError,
      },
      {
        name: "Periodic Payment Amount",
        inputName: "Periodic Payment Amount",
        required: false,
        // requiredError,
      },
      {
      name: "App Originator",
      inputName: "App Originator",
      required: false,
    },
    {
      name: "Source",
      inputName: "Source",
      required: false,
    },
    {
      name: "Sales Rep",
      inputName: "Sales Rep",
      required: false,
    },
    ],
  };

  const CSVConfigassets = {
    headers: [
      {
        name: "Contract Number",
        inputName: "Contract Number",
        required: true,
        requiredError,
      },
      // {
      //   name: "Asset No",
      //   inputName: "Asset No",
      //   required: false,
      // },
      {
        name: "Asset Desc",
        inputName: "Asset Desc",
        required: false,
      },
      {
        name: "License No",
        inputName: "License No",
        required: false,
      },
      // {
      //   name: "Financed Amount",
      //   inputName: "Financed Amount",
      //   required: false,
      // },
      {
        name: "Year",
        inputName: "Year",
        required: false,
      },
      {
        name: "VIN Number",
        inputName: "VIN Number",
        required: false,
      },
      {
        name: "License State",
        inputName: "License State",
        required: false,
      },
      // {
      //   name: "Dealer Payable",
      //   inputName: "Dealer Payable",
      //   required: false,
      // },
      {
        name: "Manufacturer",
        inputName: "Manufacturer",
        required: false,
      },
      {
        name: "Make",
        inputName: "Make",
        required: false,
      },
      {
        name: "Model",
        inputName: "Model",
        required: false,
      },
      {
        name: "User Purpose",
        inputName: "User Purpose",
        required: false,
      },
      {
        name: "Asset Type",
        inputName: "Asset Type",
        required: false,
      },
      {
        name: "Residual Value",
        inputName: "Residual Value",
        required: false,
        // requiredError,
      },
      {
        name: "Installed Location(Address Reference)",
        inputName: "Installed Location(Address Reference)",
        required: true,
        requiredError,
      },
      {
        name: "Vendor Name(Party Reference)",
        inputName: "Vendor Name(Party Reference)",
        required: true,
        requiredError,
      },
      {
        name: "Delivery Date",
        inputName: "Delivery Date",
        required: false,
      },
      {
        name: "In-Service Date",
        inputName: "In-Service Date",
        required: false,
      },
      {
        name: "Milage",
        inputName: "Milage",
        required: false,
      },
      {
        name: "Vehicle Cost",
        inputName: "Vehicle Cost",
        required: true,
        requiredError,
      },
      {
        name: "Vehicle Cost Pay To",
        inputName: "Vehicle Cost Pay To",
        required: false,
      },
      {
        name: "Tax",
        inputName: "Tax",
        required: false,
      },
      {
        name: "Tax Pay To",
        inputName: "Tax Pay To",
        required: false,
      },
      {
        name: "Trade In",
        inputName: "Trade In",
        required: false,
      },
      {
        name: "Trade In Pay To",
        inputName: "Trade In Pay To",
        required: false,
      },
      {
        name: "Registration",
        inputName: "Registration",
        required: false,
      },
      {
        name: "Registration Pay To",
        inputName: "Registration Pay To",
        required: false,
      },
      // {
      //   name: "Total Cost",
      //   inputName: "Total Cost",
      //   required: false,
      // },
      {
        name: "Down Payment",
        inputName: "Down Payment",
        required: false,
      },
      {
        name: "Down Payment Pay To",
        inputName: "Down Payment Pay To",
        required: false,
      },
      {
      name: "Condition",
      inputName: "Condition",
      required: false,
    },
    {
      name: "Vendor Asset ID",
      inputName: "Vendor Asset ID",
      required: false,
    },
    {
      name: "Salvage Value",
      inputName: "Salvage Value",
      required: false,
    },
    ],
  };

  const CSVConfigpartyaddress = {
    headers: [
      {
        name: "Party Reference",
        inputName: "Party Reference",
        required: true,
        requiredError,
      },
      {
        name: "Address Line 1",
        inputName: "Address Line 1",
        required: true,
        requiredError,
      },
      {
        name: "Address Line 2",
        inputName: "Address Line 2",
        required: false,
        // requiredError
      },
      {
        name: "Country",
        inputName: "Country",
        required: true,
        requiredError,
      },
      {
        name: "State",
        inputName: "State",
        required: true,
        requiredError,
      },
      {
        name: "City",
        inputName: "City",
        required: true,
        requiredError,
      },
      {
        name: "Zip Code",
        inputName: "Zip Code",
        required: true,
        requiredError,
      },
      {
        name: "Bill To",
        inputName: "Bill To",
        required: false,
      },
      {
        name: "Ship To",
        inputName: "Ship To",
        required: false,
      },
      {
        name: "Install At",
        inputName: "Install At",
        required: false,
      },
    ],
  };

  const CSVConfigreceipt = {
    headers: [
      {
        name: "Receipt Method",
        inputName: "Receipt Method",
        required: true,
        requiredError,
      },
      {
        name: "Customer (Party Reference)",
        inputName: "Customer (Party Reference)",
        required: true,
        requiredError,
      },
      {
        name: "Contract Number(Contractnumber Reference)",
        inputName: "Contract Number(Contractnumber Reference)",
        required: false,
        requiredError,
      },
      {
        name: "Remittance Bank",
        inputName: "Remittance Bank",
        required: false,
        // requiredError,
      },
      {
        name: "Receipt Amount",
        inputName: "Receipt Amount",
        required: true,
        requiredError,
      },
      {
        name: "Receipt Reference",
        inputName: "Receipt Reference",
        required: false,
        // requiredError,
      },
      {
        name: "Receipt Date",
        inputName: "Receipt Date",
        required: true,
        requiredError,
      },
    ],
  };

  const CSVConfigInvoiceHeader = {
    headers: [
      {
        name: "Contract Number(Contractnumber Reference)",
        inputName: "Contract Number(Contractnumber Reference)",
        required: false,
        // requiredError
      },
      {
        name: "Description",
        inputName: "Description",
        required: false,
        // requiredError,
      },
      {
        name: "Notes",
        inputName: "Notes",
        required: false,
        // requiredError,
      },
      {
        name: "Transaction Type",
        inputName: "Transaction Type",
        required: false,
        // requiredError,
      },
      {
        name: "Due Date",
        inputName: "Due Date",
        required: true,
        requiredError,
      },
      {
        name: "Fee Type(Line Type)",
        inputName: "Fee Type(Line Type)",
        required: false,
        // requiredError,
      },
      {
        name: "Description(Line Type)",
        inputName: "Description(Line Type)",
        required: false,
        // requiredError,
      },
      {
        name: "Amount(Line Type)",
        inputName: "Amount(Line Type)",
        required: true,
        requiredError,
      },
      {
        name: "Tax(Line Type)",
        inputName: "Tax(Line Type)",
        required: false,
      },
    ],
  };

  const CSVConfigTaxRateHeader = {
    headers: [
      {
        name: "State",
        inputName: "State",
        required: false,
        requiredError
      },
      {
        name: "Zip",
        inputName: "Zip",
        required: true,
        requiredError,
      },
      {
        name: "Tax Region",
        inputName: "Tax Region",
        required: true,
        requiredError,
      },
      // {
      //   name: "Combined Rate",
      //   inputName: "Combined Rate",
      //   required: true,
      //   requiredError,
      // },
      {
        name: "State Rate",
        inputName: "State Rate",
        required: true,
        // requiredError,
      },
      {
        name: "County Rate",
        inputName: "County Rate",
        required: true,
        // requiredError,
      },
      {
        name: "City Rate",
        inputName: "City Rate",
        required: true,
        // requiredError,
      },
      {
        name: "Special Rate",
        inputName: "Special Rate",
        required: true,
        // requiredError,
      },
      {
        name: "Start Date",
        inputName: "Start Date",
        required: true,
        requiredError
      },
      {
        name: "End Date",
        inputName: "End Date",
        required: false,
      },
    ],
  };
  const CSVConfigInventoryHeader = {
    headers: [
      // {
      //   name: "Item Name",
      //   inputName: "Item Name",
      //   required: false,
      // },
      {
        name: "Description",
        inputName: "Description",
        required: true,
        requiredError,
      },
      {
        name: "Serial Number",
        inputName: "Serial Number",
        required: false,
      },
      {
        name: "Manufacturer",
        inputName: "Manufacturer",
        required: false,
      },
      {
        name: "Model",
        inputName: "Model",
        required: false,
      },
      {
        name: "Make",
        inputName: "Make",
        required: false,
      },
      {
        name: "In Service Date",
        inputName: "In Service Date",
        required: false,
      },
      {
        name: "Life In Months",
        inputName: "Life In Months",
        required: false,
      },
      {
        name: "Netbook Value",
        inputName: "Netbook Value",
        required: true,
        requiredError,
      },
      {
        name: "Original Cost",
        inputName: "Original Cost",
        required: true,
        requiredError,
      },
      {
        name: "Item Type",
        inputName: "Item Type",
        required: true,
        requiredError,
      },
      {
        name: "Status",
        inputName: "Status",
        required: true,
        requiredError,
      },
    ],
  };

  const CSVConfigAch = {
    headers: [
      {
        name: "Party Reference",
        inputName: "Party Reference",
        required: true,
        requiredError,
      },
      {
        name: "Account Name",
        inputName: "Account Name",
        required: true,
        requiredError,
      },
      {
        name: "ABA Routing Number",
        inputName: "ABA Routing Number",
        required: true,
        requiredError,
      },
      {
        name: "Account Number",
        inputName: "Account Number",
        required: true,
        requiredError,
      },
      {
        name: "Authorization Expiration Date",
        inputName: "Authorization Expiration Date",
        required: false,
      },
      {
        name: "Authorization Received",
        inputName: "Authorization Received",
        required: false,
 
      },
      {
        name: "One Time Use Only",
        inputName: "One Time Use Only",
        required: false,
   
      },
      {
        name: "Status",
        inputName: "Status",
        required: false,
      
      },
      {
        name: "Default",
        inputName: "Default",
        required: false,
        
      },
    ],
  };



  const blobToFile = (theBlob, fileName) => {
    const file = new File([theBlob], fileName, { type: 'text/csv' });
    return file;
  }

  const handleChange1 = (e) => {
    setApiResponse(null)
    setCsvData([])
    var reader = new FileReader();
    reader.onload = function (event) {
      var fileContent = event.target.result;
      let dataArray = fileContent.split('\n');
      if (dataArray[0].trim().endsWith('Error')) { 
        for (let i = 0; i < dataArray.length; i++) {
          let parts = dataArray[i].split(',');
          parts.pop();
          dataArray[i] = parts.join(',');
        }
      }

      const rowsArray = [];
      if (dataArray.length > 0) {
        if (dataArray[0] && dataArray[0].trim() !== '') {
          const firstRowValues = dataArray[0].split(',').map(value => value.trim());
          rowsArray.push(firstRowValues);
        }
      }

      const valuesArray = dataArray.slice(1).filter(value => value.trim() !== '');
      setParsedData(dataArray);
      setTableRows(rowsArray);
      // setTableRows1(rowsArray);

      setValues(valuesArray);
      const csvData = dataArray.join('\n');

      const blob = new Blob([csvData], { type: 'text/csv' });
      const csvFile = blobToFile(blob, `${select}.csv`);
      setFile(csvFile);

      if (select === "partycontact") {
        CSVFileValidator(blob, CSVConfig).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "party") {
        CSVFileValidator(blob, CSVConfigparty).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "partyaddress") {
        CSVFileValidator(blob, CSVConfigpartyaddress).then(
          (csvData) => {
            csvData.inValidData.forEach((message) => {
              if (csvData.inValidData.length > 0) {
                let foundInvalid = false;

                for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                  const currentMessage = csvData.inValidData[i];

                  if (!currentMessage.message.props) {
                    foundInvalid = true;
                    break;
                  }
                }

                if (foundInvalid) {
                  setCsvData([{ message: 'Selected Wrong Template' }]);
                } else {
                  setCsvData(csvData.inValidData);
                }
              }
            });
          }
        ).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "contract") {
        CSVFileValidator(blob, CSVConfigcontract).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "contractpayment") {
        CSVFileValidator(blob, CSVConfigcontractpayment).then(
          (csvData) => {
            csvData.inValidData.forEach((message) => {
              if (csvData.inValidData.length > 0) {
                let foundInvalid = false;

                for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                  const currentMessage = csvData.inValidData[i];

                  if (!currentMessage.message.props) {
                    foundInvalid = true;
                    break;
                  }
                }

                if (foundInvalid) {
                  setCsvData([{ message: 'Selected Wrong Template' }]);
                } else {
                  setCsvData(csvData.inValidData);
                }
              }
            });
          }
        ).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "additionalparties") {
        CSVFileValidator(blob, CSVAdditionalParties).then(
          (csvData) => {
            csvData.inValidData.forEach((message) => {
              if (csvData.inValidData.length > 0) {
                let foundInvalid = false;

                for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                  const currentMessage = csvData.inValidData[i];

                  if (!currentMessage.message.props) {
                    foundInvalid = true;
                    break;
                  }
                }

                if (foundInvalid) {
                  setCsvData([{ message: 'Selected Wrong Template' }]);
                } else {
                  setCsvData(csvData.inValidData);
                }
              }
            });
          }
        ).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "contractassets") {
        CSVFileValidator(blob, CSVConfigassets).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }
              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      } else if (select === "contractassets") {
        CSVFileValidator(blob, CSVAdditionalParties).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }
              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      }
      else if (select === "invoice") {
        CSVFileValidator(blob, CSVConfigInvoiceHeader).then(
          (csvData) => {
            csvData.inValidData.forEach((message) => {
              if (csvData.inValidData.length > 0) {
                let foundInvalid = false;

                for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                  const currentMessage = csvData.inValidData[i];

                  if (!currentMessage.message.props) {
                    foundInvalid = true;
                    break;
                  }
                }

                if (foundInvalid) {
                  setCsvData([{ message: 'Selected Wrong Template' }]);
                } else {
                  setCsvData(csvData.inValidData);
                }
              }
            });
          }
        ).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      }
      else if (select === "receipt") {
        CSVFileValidator(blob, CSVConfigreceipt).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      }
      else if (select === "taxrate") {
        CSVFileValidator(blob, CSVConfigTaxRateHeader).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      }
      else if (select === "inventory") {
        CSVFileValidator(blob, CSVConfigInventoryHeader).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })

        });
      }
      else if (select === "achAccounts") {
        CSVFileValidator(blob, CSVConfigAch).then((csvData) => {
          csvData.inValidData.forEach((message) => {
            if (csvData.inValidData.length > 0) {
              let foundInvalid = false;

              for (let i = 0; i < Math.min(csvData.inValidData.length, 4); i++) {
                const currentMessage = csvData.inValidData[i];

                if (!currentMessage.message.props) {
                  foundInvalid = true;
                  break;
                }
              }

              if (foundInvalid) {
                setCsvData([{ message: 'Selected Wrong Template' }]);
              } else {
                setCsvData(csvData.inValidData);
              }
            }
          });
        }).catch((error) => {
          toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        });
      }
      else {
        alert("please select the type");
      }
    };

    reader.readAsText(e.target.files[0]);
  };

  const handelOnChange = (e) => {
    setSelect(e.target.value);
    setValues([]);
    setFile([]);
    setParsedData([]);
    setCsvData([]);
    setApiResponse(null);
    reset({
      import: e.target.value,
      importfile: "",
    });
  };

  const handleRegister1 = () => {
    if (file.length !== 0) {
      if (csvData.length > 0) {
        toast.error("Required information is missing.");
      } else {
        if (select === "party") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfileparty(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);

                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "partyaddress") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfilepartyaddress(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);

                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);

                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "partycontact") {
          if (csvData.length > 0) {
            toast.error("fixed errors and re-submit");
          } else {
            const form_data1 = new FormData();
            form_data1.append("file", file);
            form.current.validateAll();

            if (checkBtn.current.context._errors.length === 0) {
              EditCompanyService.excelfilepartycontact(
                form_data1.get("file")
              ).then((response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }).catch((error) => {
                toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                  position: "top-right",
                  autoClose: 4000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                })
        
              });
            }
          }
        } else if (select === "contract") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfilecontract(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "contractpayment") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfilecontractpaymentschedule(
              form_data1.get("file")
            ).then((response) => {
              if (response.data.success) {
                setSuccessful(true);
                setLoading(false);
                if (response.data.success === 1) {
                  setMessage("Successfully added all rows.");
                } else if (response.data.success === 0) {
                  setApiResponse(response.data);
                  setMessage("Failed to add some rows. Check the errors below.");
                }
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              } else {
                setApiResponse(response.data);
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setSuccessful(false);
              }
            }).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "contractassets") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfilecontractassets(
              form_data1.get("file")
            ).then((response) => {
              if (response.data.success) {
                setSuccessful(true);
                setLoading(false);
                if (response.data.success === 1) {
                  setMessage("Successfully added all rows.");
                } else if (response.data.success === 0) {
                  setApiResponse(response.data);
                  setMessage("Failed to add some rows. Check the errors below.");
                }
                toast.success(`${response.data.response}`, {
                  position: "top-right",
                  autoClose: 1000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setTimeout(() => {
                  window.location.reload();
                }, 2000);
              } else {
                setApiResponse(response.data);
                toast.error(`${response.data.error}`, {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setSuccessful(false);
              }
            }).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "invoice") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfileinvoice(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        } else if (select === "receipt") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfilereceipt(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        }
        else if (select === "taxrate") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfiletaxrate(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        }
        else if (select === "additionalparties") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfileAdditionalparties(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        }
        else if (select === "inventory") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfileInventory(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        }
        else if (select === "achAccounts") {
          const form_data1 = new FormData();
          form_data1.append("file", file);
          form.current.validateAll();

          if (checkBtn.current.context._errors.length === 0) {
            EditCompanyService.excelfileachaccounts(form_data1.get("file")).then(
              (response) => {
                if (response.data.success) {
                  setSuccessful(true);
                  setLoading(false);
                  if (response.data.success === 1) {
                    setMessage("Successfully added all rows.");
                  } else if (response.data.success === 0) {
                    setApiResponse(response.data);
                    setMessage(
                      "Failed to add some rows. Check the errors below."
                    );
                  }
                  toast.success(`${response.data.response}`, {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setTimeout(() => {
                    window.location.reload();
                  }, 2000);
                } else {
                  setApiResponse(response.data);
                  toast.error(`${response.data.error}`, {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                  });
                  setSuccessful(false);
                }
              }
            ).catch((error) => {
              toast.error('Something went wrong, Please log a support ticket or send email to support@athenafintech.com', {
                position: "top-right",
                autoClose: 4000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              })
      
            });
          }
        }
        else {
          console.log("error ");
        }
      }
     
          
    } else {
      toast.error('Please Choose File', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  };

  useEffect(() => {
    if (csvData.length !== 0) {
      if (csvData[0]?.message !== 'Selected Wrong Template') {
        setErrorsBotton(true)
      } else {
        setErrorsBotton(false)
      }
    }
  }, [ErrorsBotton, csvData.length, csvData])

  const handelInputChange = (value) => {
    setValue(value);
    setCurrentPage2(1);
    setOptions2([]);
    loadOptions(value, 1);
  };

  const handleMenuScrollToBottomName = () => {
    loadOptions(inputvalue, currentPage2);
  };

  const handelChange = (value) => {
    setSelectedValue(value);
  };

  const loadOptions = async (value, page) => {
    try {
      if (value !== '') {
        setIsLoading2(true);
        const response = await fetch(`${API}helper/ajax/load-allstates/?state_name=${value}&page=${page}`, { headers: authHeader() });
        const newData = await response.json();

        if (newData && newData.data && newData.data.length > 0) {
          const newOptions = newData.data

          setOptions2((prevOptions) => [...prevOptions, ...newOptions]);
          setCurrentPage2((prevPage) => prevPage + 1);
        } else {
          console.error('No data received or empty array from API.');
        }
        setIsLoading2(false);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setIsLoading2(false);
    }
  };


  return (
    <div className="container-fluid">
      <ToastContainer />
      <div className="header pb-0 pt-3 mb-3">
        <div className="d-lg-flex">
          <div>
            <h5 className="mb-1">{t("Import")}</h5>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="col-md-4 card-body">
          <div>
            <span className="mb-0 tc required">{t("Select Import")}</span>
            <select
              className="form-control form-select  mb-1"
              {...register("import", { required: true })}
              value={select}
              name="import"
              onChange={handelOnChange}
            >
              <option value="">{t("Select ")}</option>
              <option value="party">{t("Party")}</option>
              <option value="achAccounts">{t("Party Bank Accounts")}</option>
              <option value="partyaddress">{t("Party Address")}</option>
              <option value="partycontact">{t("Party Contact")}</option>
              <option value="contract">{t("Contract")}</option>
              <option value="contractpayment">{t("Payment Schedule")}</option>
              <option value="contractassets">{t("Assets")}</option>
              <option value="additionalparties">{t("Additional Parties")}</option>
              <option value="invoice">{t("Invoice")}</option>
              <option value="receipt">{t("Receipt")}</option>
              <option value="taxrate">{t("Tax Rate")}</option>
              <option value="inventory">{t("Inventory")}</option>

            </select>
            <div className="invalid-feedback">
              {errors.import?.type === "required" && "Object is required"}
            </div>
          </div>
        </div>
        <div className="card-body col-md-8">

          <Form
            role="form text-left"
            onSubmit={handleSubmit(handleRegister1)}
            ref={form}
            action="."
            method="POST"
          >
            {
              <>
                <input
                  type="file"
                  className="col-md-12 mb-3 pt-3"
                  id="file"
                  accept=".csv"
                  {...register("importfile", { required: false })}
                  onChange={handleChange1}
                  name="importfile"
                  multiple
                ></input>
                <div className="invalid-feedback">
                  {errors.importfile?.type === "required" &&
                    "Select file  is required"}
                </div>
                <button className="btn btn-primary pt-3 " type="submit">
                  {t("Submit")}
                </button>
                &nbsp;&nbsp;
                {party && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Party.csv"
                    }
                  >
                    Template for Bulk Party Upload
                  </a>
                )}
                {partyaddress && (
                  <>
                    <a
                      href={
                        process.env.PUBLIC_URL +
                        "/static/assets/excelsfor athena/Party Address.csv"
                      }
                    >
                      Template for Bulk Party Address Upload
                    </a>
                    < div className="form-group d-flex flex-wrap " >
                      <label className=" "  ><h5 className="tc required">Please verify the names of the states and countries using the filter list below.</h5></label>
                    </div>
                    <div className="form-group d-flex flex-wrap col-md-7">
                      <div className="flex-grow-1 me-3 mb-3">
                        <label htmlFor="country">Country</label>
                        <select
                          type="text"
                          name="country_name"
                          className="form-control"
                          {...register("country", {
                            onChange: (e) => {
                              //  trigger();
                              handlecountry(e);
                            },
                            required: false,
                          })}
                        >
                          <option value="">---Select Country---</option>
                          {country_name.map((countryget) => (
                            <option
                              key={countryget.id}
                              value={countryget.id}
                            >
                              {countryget.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.country?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                      <div className="flex-grow-1 me-3 mb-3">
                        <label htmlFor="state">State</label>
                        <select
                          name="state"
                          className="form-control"
                          {...register("state", {
                            onChange: (e) => {
                              //  trigger();
                              handlestate(e);
                            },
                            required: false,
                          })}
                        >
                          <option value="">---Select State---</option>
                          {state_name.map((resst) => (
                            <option key={resst.id} value={resst.id}>
                              {resst.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.state?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                    </div>
                  </>
                )}
                {partycontact && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Party Contact.csv"
                    }
                  >
                    Template for Bulk Party Contact Upload
                  </a>
                )}
                {conracts && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Contract.csv"
                    }
                  >
                    Template for Bulk Contract Upload
                  </a>
                )}
                {contractpayment && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Payment Schedule.csv"
                    }
                  >
                    Template for Bulk Payment Schedule Upload
                  </a>
                )}
                {contractasset && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Assets.csv"
                    }
                  >
                    Template for Bulk Assets Upload
                  </a>
                )}
                {invoice && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Invoice.csv"
                    }
                  >
                    Template for Bulk Invoice Upload
                  </a>
                )}
                {receipt && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Receipt.csv"
                    }
                  >
                    Template for Bulk Receipt Upload
                  </a>
                )}
                {taxRate && (
                  <><a
                    href={process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Tax Rate.csv"}
                  >
                    Template for Bulk Tax Rate Upload
                  </a><div className="form-group d-flex flex-wrap ">
                      <label className=" "><h5 className="tc required">Please verify the names of the states using the filter list below.</h5></label>
                    </div>
                    <div className="form-group d-flex flex-wrap col-md-7">
                      <div className="flex-grow-1 me-3 mb-3">
                        <label htmlFor="country">Country</label>
                        <select
                          type="text"
                          name="countryname"
                          className="form-control"
                          {...register("countryname", {
                            onChange: (e) => {
                              //  trigger();
                              handlecountryTax(e);
                            },
                            required: false,
                          })}
                          disabled
                        >
                          {/* <option value="">---Select Country---</option> */}
                          {TaxCoutry.map((countryget) => (
                            <option
                              key={countryget.id}
                              value={countryget.id}
                            >
                              {countryget.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.countryname?.type === "required" &&
                            "Country is required"}
                        </div>
                      </div>
                      <div className="flex-grow-1 me-3 mb-3">
                        <label htmlFor="state">State</label>
                        <select
                          name="state"
                          className="form-control"
                          {...register("state", {
                            onChange: (e) => {
                              //  trigger();
                              handlestateTax(e);
                            },
                            required: false,
                          })}
                        >
                          <option value="">---Select State---</option>
                          {TaxState.map((resst) => (
                            <option key={resst.id} value={resst.id}>
                              {resst.name}
                            </option>
                          ))}
                        </select>
                        <div className="invalid-feedback">
                          {errors.state?.type === "required" &&
                            "State is required"}
                        </div>
                      </div>
                      {/* <div className="flex-grow-1 me-3 mb-3">
                        <label htmlFor="State">State</label>
                        <Select
                          value={selectedValue}
                          filterOption={false}
                          options={options2}
                          defaultValue={options2}
                          isClearable
                          onInputChange={handelInputChange}
                          getOptionLabel={(options) => options.name}
                          getOptionValue={(options) => options.id}
                          isLoading={isLoading2}
                          placeholder={t("Search for State(%for All)")}
                          onMenuScrollToBottom={handleMenuScrollToBottomName}
                          onChange={handelChange}
                        />
                      </div> */}
                    </div>
                  </>
                )}
                {inventory && (
                  <a
                    href={
                      process.env.PUBLIC_URL +
                      "/static/assets/excelsfor athena/Inventory.csv"
                    }
                  >
                    Template for Bulk Inventory Upload
                  </a>
                )}
                  {achAccounts && (
                  <a href={process.env.PUBLIC_URL + "/static/assets/excelsfor athena/Party Bank Accounts.csv"}>
                    Template for Bulk Party Bank Accounts Upload
                  </a>
                )}
                  {additionalparties && (
                  <a href={process.env.PUBLIC_URL + "/static/assets/excelsfor athena/Addtional Parties.csv"}>
                    Template for Bulk Addtional Parties Upload
                  </a>
                )}
              </>
            }

            <CheckButton style={{ display: "none" }} ref={checkBtn} />
          </Form>
        </div>
        <span className="card-body">
          {csvData.map((post) => (
            <div className="invalid-feedback" key={post.rowIndex}>
              {post.message}
            </div>
          ))}

          {apiResponse &&
            apiResponse.errors.map((error, index) => (
              <div key={index} className="invalid-feedback">
                Error in Row {error.row_index} : {error.error}
              </div>
            ))}
        </span>

        <div className="card-body table-responsive col-md-11">
          {message && <div>{message}</div>}
          {(ErrorsBotton || apiResponse) && (
            <button
              className="btn btn-primary btn-sm mt-3"
              onClick={downloadErrors}
            >
              Download Errors
            </button>
          )}<br />
          {parsedData.length > 0 ? (
            <>
              <span className="tc">{t("Preview")}</span>
              <table className="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                      index
                    </th>
                    {tableRows[0].map((header, index) => (
                      <th
                        className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
                        key={index}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {values.map((row, rowIndex) => {
                    const hasError = apiResponse && apiResponse.errors.some(error => error.row_index === rowIndex + 1);

                    return (
                      <tr key={rowIndex} className={hasError ? "highlighted-row" : ""}>
                        <td>{rowIndex + 1}</td>
                        {row.split(',').map((cell, cellIndex) => (
                          <td key={cellIndex}>{cell}</td>
                        ))}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </>
          ) : ""}

        </div>
      </div>
    </div>
  );
}

export default Import;
